import script from "./MenuPosition.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuPosition.vue?vue&type=script&setup=true&lang=js"

import "./MenuPosition.vue?vue&type=style&index=0&id=013205bd&scoped=true&lang=scss"

import exportComponent from "/home/beta/domains/architect-beta.youniversity.be/public_html/architect/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-013205bd"]])

export default __exports__